import React from 'react';
import { BadgeCheckIcon, CalendarIcon, ChartNoAxesColumnIcon, ClipboardListIcon, ImageIcon, MegaphoneIcon, MessageSquareIcon, SettingsIcon, UsersIcon, VoteIcon } from 'lucide-react';
import { OperatorShell } from './OperatorShell';
import type { NavGroup } from './OperatorShell';
import { Badge } from '../ui/Badge';
import { communityProfile } from '../../data/communityConsole';

/**
 * The Community workspace shell.
 *
 * A society is an organization, so this is a member-first console: people,
 * what was said to them, and what they turned up to. It deliberately does not
 * lead with engagement volume — a society is run by who shows up, not by
 * reaction counts.
 */

const GROUPS: NavGroup[] = [{
  label: 'Community',
  items: [{
    to: '/community-workspace',
    label: 'Overview',
    icon: ChartNoAxesColumnIcon,
    end: true
  }, {
    to: '/community-workspace/members',
    label: 'Members',
    icon: UsersIcon
  }]
}, {
  label: 'Content',
  items: [{
    to: '/community-workspace/posts',
    label: 'Posts',
    icon: MessageSquareIcon
  }, {
    to: '/community-workspace/announcements',
    label: 'Announcements',
    icon: MegaphoneIcon
  }, {
    to: '/community-workspace/polls',
    label: 'Polls',
    icon: VoteIcon
  }, {
    to: '/community-workspace/media',
    label: 'Media',
    icon: ImageIcon
  }]
}, {
  label: 'Events',
  items: [{
    to: '/community-workspace/events',
    label: 'Events',
    icon: CalendarIcon
  }, {
    to: '/community-workspace/registrations',
    label: 'Registrations',
    icon: ClipboardListIcon
  }]
}, {
  label: 'Organisation',
  items: [{
    to: '/community-workspace/settings',
    label: 'Settings',
    icon: SettingsIcon
  }]
}];
export function CommunityShell() {
  return <OperatorShell consoleKey="community" consoleName="Community console" scopeLine={`${communityProfile.name} · ${communityProfile.campus}`} groups={GROUPS} summary={<div data-id="element-4495" data-mp="3j5rp85nolwte">
          <p className="text-caption text-ink-muted" data-id="element-4496" data-mp="3j5i0smiabxpt">Members</p>
          <p className="cz-num mt-1 text-h4 font-semibold text-ink" data-id="element-4497" data-mp="qbt70vfh5ijx">
            {communityProfile.members.toLocaleString()}
          </p>
          {communityProfile.recognised && <Badge tone="ok" className="mt-2" icon={<BadgeCheckIcon className="h-3.5 w-3.5" data-id="element-4499" data-mp="10507q2z9sado" />} data-id="element-4498" data-mp="101vvqjfkcacg">
              Recognised society
            </Badge>}
        </div>} data-id="element-4494" data-mp="fkvqbm4p430u" />;
}